// src/components/FloatingContactBubble.js

import React, { useState } from "react";
import "./styles.css";
import ScrollToTopButton from "../ScrollToTopButton";
const contactOptions = [
  {
    name: "Zalo",
    icon: "Z",
    link: "https://zalo.me/0866306661",
    color: "#0068ff",
  }, // Zalo thường dùng số điện thoại
  { name: "Gọi Điện", icon: "☎", link: "tel:0866306661", color: "#4CAF50" },
  {
    name: "Facebook",
    icon: "f",
    link: "https://m.me/yourfacebookpage",
    color: "#1877F2",
  }, // Dùng m.me cho Messenger
  {
    name: "Email",
    icon: "✉",
    link: "mailto:info@habakome.com",
    color: "#D93025",
  },
];

const FloatingContactBubble = () => {
  // State để quản lý trạng thái mở/đóng của bong bóng menu
  const [isOpen, setIsOpen] = useState(false);

  const toggleBubble = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="floating-contact-bubble">
      {}
      <div className={`contact-menu ${isOpen ? "open" : ""}`}>
        {contactOptions.map((option, index) => (
          // Mỗi lựa chọn liên hệ
          <a
            key={index}
            href={option.link}
            target="_blank"
            rel="noopener noreferrer"
            className="contact-option"
            style={{ backgroundColor: option.color }}
            aria-label={`Liên hệ qua ${option.name}`}
          >
            <span className="contact-icon">{option.icon}</span>
            <span className="contact-name">{option.name}</span>
          </a>
        ))}
      </div>

      {}
      <ScrollToTopButton />
      <button
        className={`main-bubble-btn ${isOpen ? "active" : ""}`}
        onClick={toggleBubble}
        aria-expanded={isOpen}
      >
        {}
        {isOpen ? "✖" : "Liên Hệ"}
      </button>
    </div>
  );
};

export default FloatingContactBubble;
